module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/Halfstar.e138b9b0.svg";